



























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { uploadLocalisationKeys } from '@/features/upload/upload.localisation'
import SheetList from '@/features/upload/components/SheetList.vue'

@Component({
  components: {
    SheetList
  }
})
export default class ChooseSheetDialog extends Vue {
  private translations = uploadLocalisationKeys
  private showDialog: boolean = false
  private sheetNames: string[] = []
  private sheet = ''

  @Emit('chooseSheetName')
  selectedSheetName (selectedSheetName: string): void { }

  public openDialog (sheetNames: string[]): void {
    this.sheetNames = sheetNames
    this.showDialog = true
  }

  public selectSheet (selectedSheetName: string): void {
    this.sheet = selectedSheetName
  }

  public sentSheetName (): void {
    this.selectedSheetName(this.sheet)
  }
}
